// removed by extract-text-webpack-plugin
module.exports = {"header":"src-components-header----header-module---header---L1ZnK","title":"src-components-header----header-module---title---EMxyd","headline":"src-components-header----header-module---headline---33Jlw","bookshelf":"src-components-header----header-module---bookshelf---1UjG-","typewriter":"src-components-header----header-module---typewriter---2HQ9T"};


//////////////////
// WEBPACK FOOTER
// ./src/components/header/header.module.css
// module id = 310
// module chunks = 35783957827783